export const tr = {
    add: 'Reklam grubuna ekle'
};
